import { Typography } from './Typography';
import styles from './ClientStrip.module.css';
const names = ['KATCO', 'Baker Hughes', 'Kazakh Tourism', 'ЗЕНИТ', 'Bureau Veritas', 'МетСталь'];
export function ClientStrip({ inverse = false }: { inverse?: boolean }) {
  return (
    <div
      className={`${styles.strip} ${inverse ? styles.inverse : ''}`}
      aria-label="Клиенты компании"
    >
      <div className={styles.track}>
        {[0, 1].map((copy) => (
          <div className={styles.group} key={copy} aria-hidden={copy === 1 || undefined}>
            {names.map((name) => (
              <Typography key={name} as="span" variant="client" tone="inherit">
                {name}
              </Typography>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
